import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-white rounded-xl mb-4" }
const _hoisted_2 = { class: "pb-4 mb-4 p-4 border-b" }
const _hoisted_3 = { class: "px-4 pb-3 grid grid-cols-1 gap-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-lp-500" }, " Aktifkan opsi ini untuk memaksa status menjadi kedaluwarsa secara langsung, tanpa menunggu waktu yang ditentukan. ", -1)
const _hoisted_5 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Toggle = _resolveComponent("Toggle")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Title, { label: "Status Kedaluwarsa Konfig" })
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Toggle, {
          modelValue: _ctx.toggleValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleValue = $event)),
          "text-active": "Belum kedaluwarsa",
          "text-inactive": "Kedaluwarsa",
          "style-active": 'bg-red-lp-100',
          "style-inactive": 'bg-gray-lp-200'
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}